import React from "react";

import "../indicator.css";

interface IIndicatorProps {
    text?: string;
    icon?: string;
    color?: string;
    type?: string;
    title?: string;
}

class Indicator extends React.Component<IIndicatorProps> {
    public render() {
        return (
            <span className={`indicator ${this.props.type ? `indicator-type-${this.props.type}` : ""} indicator-${this.props.color || "default"}`} title={this.props.title}>
                {this.props.icon ? <i className={`icon-${this.props.icon}`} /> : null}
                {this.props.children
                    ? this.props.children
                    : this.props.text
                        ? <span>{this.props.text}</span>
                        : null}
            </span>
        );
    }
}

export default Indicator;
